
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftRight0 as ObiThreewayAnalogInleftRight0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-right-0.js';
 
 
 

 
 export const ObiThreewayAnalogInleftRight0 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-right-0',
   elementClass: ObiThreewayAnalogInleftRight0Element,
   events: {
     
   }
  });
 
 